import React, { Component } from 'react';
import PropTypes from 'prop-types';

import PostReg from '../../PostReg/index.tsx';

class Complete extends Component {
  render() {
    return (
      <PostReg {...this.props} resolvesErrorId={this.props.activeErrorId} />
    );
  }
}

Complete.propTypes = {
  activeErrorId: PropTypes.string
};

export default Complete;
